/* eslint-disable no-param-reassign */
import { sortTypeEnum } from '@/constants/global';
import { vuexEventPathGenerator } from '@/utils';
// enum 으로 하면 no-shadow 버그 발생  as const 형태로 진행
// export enum MutationType {
//   SET_FILTER_OPTION = 'SET_FILTER_OPTION',
// }
export const mutationType = {
    SET_FILTER_OPTION: 'SET_FILTER_OPTION',
    SET_SORT_OPTION: 'SET_SORT_OPTION',
    GET_WORKER_LIST: 'GET_WORKER_LIST',
};
export const workerListMutationType = vuexEventPathGenerator(mutationType, 'workerManagement/workerList');
const mutations = {
    [mutationType.SET_FILTER_OPTION]({ filterOption }, payload) {
        Object.entries(payload).forEach(([key, value,]) => {
            filterOption[key] = value;
        });
    },
    [mutationType.SET_SORT_OPTION]: (state, payload) => {
        state.sortOption = payload.length > 0 ? payload : [
            {
                // 정렬 대상
                field: 'name',
                // 정렬 기준
                value: sortTypeEnum.ASC,
            },
        ];
    },
    [mutationType.GET_WORKER_LIST](state, payload) {
        state.paginationData = payload.paginationData;
        state.workerList = payload.list;
    },
};
export default mutations;
